// import { OperatorEnum } from '@lib/shared/enums/commonEnum';
// import { FieldTypeEnum } from '@lib/shared/enums/formDesignEnum';

// 大于等于 label：含义   value:值   //搜索属性的类型
export const GE = { label: 'advanceFilter.operator.ge', value: 'GE' };
// 在范围内
export const IN = { label: 'advanceFilter.operator.belongTo', value: 'IN' };
// 不在范围内
export const NOT_IN = { label: 'advanceFilter.operator.notBelongTo', value: 'NOT_IN' };
// 大于
export const GT = { label: 'advanceFilter.operator.gt', value: 'GT' };
// 小于
export const LT = { label: 'advanceFilter.operator.lt', value: 'LT' };
// 小于等于
export const LE = { label: 'advanceFilter.operator.le', value: 'LE' };
// 等于
export const EQUAL = { label: 'advanceFilter.operator.equal', value: 'EQUALS' };
// 不等于
export const NOT_EQUAL = { label: 'advanceFilter.operator.notEqual', value: 'NOT_EQUALS' };
// 介于
export const BETWEEN = { label: 'advanceFilter.operator.between', value: 'BETWEEN' };
// 数量大下
export const COUNT_GT = { label: 'advanceFilter.operator.countGt', value: 'COUNT_GT' };
// 数量小于
export const COUNT_LT = { label: 'advanceFilter.operator.countLt', value: 'COUNT_LT' };
// 为空
export const EMPTY = { label: 'advanceFilter.operator.empty', value: 'EMPTY' };
// 不为空
export const NOT_EMPTY = { label: 'advanceFilter.operator.not_empty', value: 'NOT_EMPTY' };
// 包含
export const CONTAINS = { label: 'advanceFilter.operator.contains', value: 'CONTAINS' };
// 不包含
export const NO_CONTAINS = { label: 'advanceFilter.operator.not_contains', value: 'NOT_CONTAINS' };
// 动态
export const DYNAMICS = { label: 'advanceFilter.operator.dynamics', value: 'DYNAMICS' };
// 固定
export const FIXED = { label: 'advanceFilter.operator.betweenFixed', value: 'FIXED' };
// 通用文本符号
const COMMON_TEXT_OPERATORS = [CONTAINS, NO_CONTAINS, EMPTY, NOT_EMPTY, EQUAL, NOT_EQUAL];
// 通用选择符号
const COMMON_SELECTION_OPERATORS = [IN, NOT_IN, EMPTY, NOT_EMPTY];

export const operatorOptionsMap = {
  // 搜索属性的类型组
  INPUT: COMMON_TEXT_OPERATORS,
  TEXTAREA: COMMON_TEXT_OPERATORS,
  LINK: COMMON_TEXT_OPERATORS,
  PHONE: COMMON_TEXT_OPERATORS,
  INPUT_NUMBER: [EQUAL, GT, LT, GE, LE, EMPTY],
  SELECT: COMMON_SELECTION_OPERATORS,
  SELECT_MULTIPLE: [...COMMON_SELECTION_OPERATORS, EQUAL, NOT_EQUAL],
  RADIO: COMMON_SELECTION_OPERATORS,
  CHECKBOX: COMMON_SELECTION_OPERATORS,
  MEMBER: COMMON_SELECTION_OPERATORS,
  MEMBER_MULTIPLE: COMMON_SELECTION_OPERATORS,
  DEPARTMENT: COMMON_SELECTION_OPERATORS,
  DEPARTMENT_MULTIPLE: COMMON_SELECTION_OPERATORS,
  USER_SELECT: COMMON_SELECTION_OPERATORS,
  LOCATION: COMMON_SELECTION_OPERATORS,
  INPUT_MULTIPLE: [EMPTY, CONTAINS, NO_CONTAINS, COUNT_LT, COUNT_GT],
  DATA_SOURCE: COMMON_SELECTION_OPERATORS,
  DATA_SOURCE_MULTIPLE: COMMON_SELECTION_OPERATORS,
  TREE_SELECT: [IN, NOT_IN],
  DATE_TIME: [DYNAMICS, BETWEEN, GT, LT, EMPTY, NOT_EMPTY],
  TIME_RANGE_PICKER: [DYNAMICS, BETWEEN, GT, LT, EMPTY, NOT_EMPTY],
  SERIAL_NUMBER: COMMON_TEXT_OPERATORS,
  ATTACHMENT: [CONTAINS, NO_CONTAINS, EMPTY, NOT_EMPTY],
};

export const scopeOptions = [
  {
    value: 'Created',
    // label: t('common.newCreate'
  },
  {
    value: 'Picked',
    // label: t('common.claim'
    disabled: true,
  },
];

export const timeOptions = [
  { label: 'advanceFilter.common.today', value: 'TODAY' },
  { label: 'advanceFilter.common.yesterday', value: 'YESTERDAY' },
  { label: 'advanceFilter.common.tomorrow', value: 'TOMORROW' },
  { label: 'advanceFilter.common.thisWeek', value: 'WEEK' },
  { label: 'advanceFilter.common.lastWeek', value: 'LAST_WEEK' },
  { label: 'advanceFilter.common.nextWeek', value: 'NEXT_WEEK' },
  { label: 'advanceFilter.common.thisMonth', value: 'MONTH' },
  { label: 'advanceFilter.common.lastMonth', value: 'LAST_MONTH' },
  { label: 'advanceFilter.common.nextMonth', value: 'NEXT_MONTH' },
  { label: 'advanceFilter.common.lastSevenDays', value: 'LAST_SEVEN' },
  { label: 'advanceFilter.common.nextSevenDays', value: 'SEVEN' },
  { label: 'advanceFilter.common.lastThirtyDays', value: 'LAST_THIRTY' },
  { label: 'advanceFilter.common.nextThirtyDays', value: 'THIRTY' },
  { label: 'advanceFilter.common.lastSixtyDays', value: 'LAST_SIXTY' },
  { label: 'advanceFilter.common.nextSixtyDays', value: 'SIXTY' },
  { label: 'advanceFilter.common.thisQuarter', value: 'QUARTER' },
  { label: 'advanceFilter.common.lastQuarter', value: 'LAST_QUARTER' },
  { label: 'advanceFilter.common.nextQuarter', value: 'NEXT_QUARTER' },
  { label: 'advanceFilter.common.thisYear', value: 'YEAR' },
  { label: 'advanceFilter.common.lastYear', value: 'LAST_YEAR' },
  { label: 'advanceFilter.common.nextYear', value: 'NEXT_YEAR' },
  { label: 'advanceFilter.common.custom', value: 'CUSTOM' },
];

export const unitOptions = [
  { label: 'advanceFilter.common.day', value: 'BEFORE_DAY' },
  { label: 'advanceFilter.common.afterDay', value: 'AFTER_DAY' },
  { label: 'advanceFilter.common.week', value: 'BEFORE_WEEK' },
  { label: 'advanceFilter.common.afterWeek', value: 'AFTER_WEEK' },
  { label: 'advanceFilter.common.month', value: 'BEFORE_MONTH' },
  { label: 'advanceFilter.common.afterMonth', value: 'AFTER_MONTH' },
];
